import { snackStore } from 'stores';

import { SNACK_SCOPES } from '../../../constants';

let snackId: string;

function show(racerEmail: string, signedInEmail: string) {
  const snackParams = {
    i18key: 'changeDistance.registration.emailMismatch',
    i18params: { racerEmail, signedInEmail },
  };

  clean();
  snackId = snackStore.error(snackParams, { scope: SNACK_SCOPES.changeDistance });
}

function clean() {
  snackId && snackStore.removeValue(snackId);
}

const changeDistanceEmailMismatchSnack = {
  show,
  clean,
};

export { changeDistanceEmailMismatchSnack };
